


































import { Vue, Prop, Component } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { IFiatBalances } from '~/store/inventory/types';
import GradientHexagon from '~/components/UIComponents/GradientHexagon.vue';

@Component({ components: { GradientHexagon } })
export default class WelcomeActivated extends Vue {
  @Prop(String) readonly displayName!: string;
  @Prop(String) readonly firstName!: string;
  @Getter('galaBalance', { namespace: 'inventory' })
  readonly galaBalance!: number;

  galaCube = require('@/assets/icons/icon_gala_cube.png');

  get cubeWidth() {
    const { smAndUp, lgAndUp } = this.$vuetify.breakpoint;
    return lgAndUp ? '150px' : smAndUp ? '100px' : '80px';
  }
}
